import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import authReducer from "../api/auth/authSlice";
import orgReducer from "../api/organizations/orgSlice";
import userReducer from "../api/user/userSlice";
import snackbarReducer from "../api/snackbarSlice";
import rootSaga from "../api/rootSaga";
import loaderReducer from "../api/loader/loaderSlice";
import codeListReducer from "../api/codelist/codeListsSlice";
import subscriptionReducer from "../api/subscription/subscriptionSlice";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authReducer,
    org: orgReducer,
    user: userReducer,
    snackbar: snackbarReducer,
    loader: loaderReducer,
    codeLists: codeListReducer,
    subscription: subscriptionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
